const doc = [({"en":({"js":({"components":({"actions":({"super_admin":({"super_admin":"Super admin"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;